"use client";

import React, { useEffect, useState } from "react";
import Image from "next/image";
import axios from "axios";
import { CmsBannerDetails } from "@/interface/types";
import Link from "next/link";

const CmsBanner = () => {
  const [bannerDetails, setBannerDetails] = useState<CmsBannerDetails | null>(
    null,
  );

  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    let yOffset = 0;
    if (window.innerWidth <= 768) {
      // Mobile version
      yOffset = -100;
    } else {
      // Desktop version
      yOffset = -150;
    }

    if (section) {
      const yPosition =
        section.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: yPosition, behavior: "smooth" });
    }
  };

  const fetchBannerDetails = async () => {
    try {
      const response = await axios.get(
        "https://website-cms-backend-prod-154625965269.asia-south1.run.app/homepage?vertical=Accounting",
      );
      const { status, data } = response;
      if (status === 200) {
        setBannerDetails(data);
      } else {
        console.warn("empty array");
      }
    } catch (error) {
      console.error("failed to fetch banner details");
    }
  };

  useEffect(() => {
    fetchBannerDetails();
  }, []);

  return (
    <>
      <div>
        {bannerDetails ? (
          <div className="mx-auto w-full 2xl:h-[700px] md:h-[95vh] h-[auto] xl:px-0 md:px-6 lg:!px-6 px-5 pt-[60px] md:pt-[0px] relative md:bg-bottom bg-center bg-[url(/home/footer_bg.png)] bg-repeat bg-inherit md:bg-[length:100% 100%] md:pb-0 pb-[0px]">
            <div className="lg:container mx-auto 2xl:px-0 xl:px-10 lg:p-0 text-[#030F1C] z-20 relative">
              <div className="flex justify-between flex-wrap 2xl:items-center items-center 2xl:h-[650px] md:h-[65vh] h-[auto]">
                <div className="md:pt-5 pt-[160px] w-full md:pb-16 relative 2xl:top-[30px] md:top-[120px] ">
                  <div className="text-center relative">
                    <h1 className="md:text-[32px] text-[28px] mt-2 font-bold font-regular md:leading-[52px] leading-[1.2] my-5 capitalize">
                      {bannerDetails.title}
                    </h1>
                    <h2 className="relative capitalize px-16 text-xl font-medium">
                      {bannerDetails.subtitle}
                    </h2>
                    <h3 className="text-[24px] font-bold relative md:block hidden">
                      {bannerDetails.subtitle2}
                    </h3>
                    <div className="flex justify-center gap-4 md:gap-6 md:mt-8">
                      {bannerDetails.cta_text1 && (
                        <Link
                          href={{ pathname: bannerDetails.cta_link }}
                          className="font-semibold text-[14px] cms_sha bg-white border-[1px] border-[#FFBA08] md:px-6 px-4 py-2 rounded-[10px]"
                        >
                          {bannerDetails.cta_text1}
                        </Link>
                      )}
                      {bannerDetails.cta_text2 && (
                        <Link
                          href={{ pathname: bannerDetails.cta_link2 }}
                          className="font-semibold text-[14px] cms_sha bg-white border-[1px] border-[#FFBA08] md:px-6 px-4 py-2 rounded-[10px]"
                        >
                          {bannerDetails.cta_text2}
                        </Link>
                      )}
                    </div>
                    <div className="text-center mx-auto mt-12 md:block hidden relative md:left-[-0.65rem]">
                      <div className=" flex justify-center">
                        {bannerDetails.banner_CTA_text && (
                          <Link
                            href={{ pathname: bannerDetails.banner_CTA_link }}
                          >
                            <div
                              className="grp_btn flex justify-center items-center cursor-pointer"
                              onClick={() => scrollToSection("talent")}
                            >
                              <Image
                                priority
                                src="/images/accounting/arrow.png"
                                alt=""
                                className="new_arrow "
                                width={45}
                                height={45}
                              />
                              <p className="new__discover_btn font-medium inline-block md:px-[30px]">
                                {bannerDetails.banner_CTA_text}
                              </p>
                            </div>
                          </Link>
                        )}
                      </div>
                    </div>
                    <div className="text-center mx-auto md:mt-12 mt-6 md:hidden block">
                      <div className=" flex justify-center">
                        <Link
                          href={{ pathname: bannerDetails.banner_CTA_link }}
                        >
                          <div
                            className="grp_btn flex justify-center items-center"
                            onClick={() => scrollToSection("talentm")}
                          >
                            <Image
                              priority
                              src="/images/accounting/arrow.png"
                              alt="Background graphic for Miles Education"
                              className="new_arrow "
                              width={45}
                              height={45}
                            />
                            <p className="new__discover_btn font-medium inline-block !px-[20px]">
                              {bannerDetails.banner_CTA_text}
                            </p>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="lg_desktop">
                <Image
                  src="/cms/cms_ban.png"
                  alt="CPA Recruiting firms"
                  className="absolute top-0 bottom-0 right-0 w-full z-[-9] md:h-full"
                  width={920}
                  height={680}
                />
              </div>
            </div>
            <div className="md_desktop">
              <Image
                src="/cms/cms_ban.png"
                alt="CPA Recruiting firms"
                className="absolute top-0 bottom-0 right-0 w-full z-[0] md:h-full md:block hidden"
                width={920}
                height={680}
              />
            </div>
            <Image
              src="/cms/mob_ban.png"
              alt="accounting jobs in usa"
              className="absolute -top-10 bottom-0 right-0 left-0 md:hidden block "
              width={500}
              height={300}
            />
          </div>
        ) : null}
      </div>
    </>
  );
};

export default CmsBanner;
